import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { Box, Typography } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';

interface EmailSenderNodeData {
  label: string;
  toEmail?: string;
  subject?: string;
}

const EmailSenderNode: React.FC<NodeProps<EmailSenderNodeData>> = ({ data = { label: 'Email Sender' } }) => {
  return (
    <Box
      sx={{
        width: 140,
        height: 40,
        backgroundColor: '#ffffff',
        borderRadius: '8px',
        display: 'flex',
        alignItems: 'center',
        boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)',
        border: '1px solid #0288D1',
        px: 1,
        outline: 'none',
        '&:focus': {
          outline: 'none',
        },
        '&:hover': {
          outline: 'none',
        },
      }}
    >
      <Box
        sx={{
          width: 18,
          height: 18,
          backgroundColor: '#0288D1',
          borderRadius: '6px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mr: 1,
        }}
      >
        <EmailIcon sx={{ color: '#ffffff', fontSize: 10 }} />
      </Box>
      <Box sx={{ flex: 1 }}>
        <Typography variant="body2" sx={{ fontWeight: 500, fontSize: '9px', lineHeight: 1.2, color: '#1F2937' }}>
          {data.label}
        </Typography>
        {data.toEmail && (
          <Typography variant="caption" sx={{ fontSize: '7px', color: '#6B7280' }}>
            {data.toEmail}
          </Typography>
        )}
      </Box>
      <Handle
        type="target"
        position={Position.Left}
        style={{ background: '#000000', width: 5, height: 5 }}
      />
    </Box>
  );
};

export default EmailSenderNode;

